module.exports = __webpack_public_path__ + "img/pir-brick-vertical.ea6791b6.svg";